import { h } from 'preact';
import LoadingPulse from './LoadingPulse';

export default ({ onClick, isLoading }) => (isLoading ? (
  <LoadingPulse />
) : (
  <h6 className="signin-link-home">
    <button className="signin-link-home-button" type="submit" onClick={onClick}>
      <i className="badge-siempreplus" />
      Regístrate e inicia el proceso para acumular kilómetros
    </button>
  </h6>
));



// WEBPACK FOOTER //
// ./components/SignInLinkHome.js